// src/hooks/useInference.js
import { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { processarExperimento } from '../infra/api/ExperimentoApi';
import { getLabResultByExperimentId } from '../infra/api/labResultApi';

/**
 * Resultado do modelo para um experimento: o que já está gravado nele e o
 * processamento sob demanda. O processamento passa pelo crm-back, que chama o
 * inference e guarda o resultado no experimento (`predicao`).
 *
 * `onProcessado` recebe o experimento atualizado, para a lista refletir o resultado.
 */
export const useInference = (experiment, isOpen, onProcessado) => {
    const experimentId = experiment?.id;
    const [predicao, setPredicao] = useState(experiment?.predicao ?? null);

    useEffect(() => {
        setPredicao(experiment?.predicao ?? null);
    }, [experimentId, experiment?.predicao]);

    const dilutionFactor = Number.isFinite(Number(experiment?.diluicao))
        ? Number(experiment.diluicao)
        : 0;

    const { data: labResult, isLoading: isLoadingLab } = useQuery({
        queryKey: ['labResult', experimentId],
        queryFn: () => getLabResultByExperimentId(experimentId),
        enabled: !!experimentId && isOpen,
        staleTime: 5 * 60 * 1000,
    });

    const processMutation = useMutation({
        mutationFn: () => processarExperimento(experimentId),
        onSuccess: (atualizado) => {
            setPredicao(atualizado?.predicao ?? null);
            onProcessado?.(atualizado);
        },
    });

    return {
        labResult,
        isLoadingLab,
        predicao,
        isSubmitting: processMutation.isPending,
        error: processMutation.error,
        processExperiment: processMutation.mutate,
        dilutionFactor,
    };
};
